declare var angular: any;
declare var Fuse: any;

import * as _ from 'underscore';
import { Spheres } from '../../../../../../../../../libs/models/src';
import { omit } from 'lodash';

angular
  .module('TeacherControllers')

  .controller('TeacherSpheresHomeCtrl', [
    '$scope',
    'api',
    '$mdDialog',
    '$mdToast',
    'EXAM',
    '$mdSidenav',
    function($scope, api, $mdDialog, $mdToast, EXAM, $mdSidenav) {
      let students;
      $scope.isManager = window.location.href.includes('/m/');

      $scope.datas = {};
      let self = $scope;

      $scope.createOrEditSphere = function(
        ev,
        sphere: Partial<Spheres> | null = null
      ) {
        $mdDialog.show({
          targetEvent: ev,
          clickOutsideToClose: true,
          preserveScope: true,
          parent: angular.element(document.body),
          templateUrl:
            '/ng1/www/modules/teacher/spheres/html/dialog_create_sphere.html',

          controller: [
            '$scope',
            '$mdDialog',
            function DialogController($scope, $mdDialog) {
              $scope.theme = EXAM;

              $scope.isManager = self.isManager;

              $scope.newSphere = sphere ? { ...sphere } : {};

              api
                .getInstitutionProfiles(
                  this.type,
                  self.isManager ? 'manager' : 'teacher'
                )
                .then(data => {
                  $scope.teachers = data.profiles.filter(function(profile) {
                    return profile.is_teacher === true && !profile.is_guest;
                  });
                });

              $scope.close = function() {
                $mdDialog.cancel();
              };

              $scope.confirm = function() {
                // So it's an edit
                if (sphere) {
                  api
                    .updateSphere(
                      sphere.id,
                      omit($scope.newSphere, [
                        'id',
                        'profile_sphere_associations',
                        'teacher',
                        'is_global'
                      ])
                    )
                    .then(
                      function(data) {
                        $mdDialog.hide($scope.newSphere.name);
                        sphere.name = $scope.newSphere.name;
                        sphere.teacher_id = $scope.newSphere.teacher_id;
                        getSpheres();
                      },
                      function(error) {
                        $mdDialog.cancel();
                      }
                    );
                } else {
                  api
                    .createSphere(
                      $scope.newSphere.name,
                      self.isManager,
                      $scope.newSphere.teacher_id
                    )
                    .then(
                      function(sphere) {
                        $mdDialog.hide(sphere);
                        $scope.close();
                        getSpheres();
                      },
                      function(error) {
                        $mdDialog.cancel();
                      }
                    );
                }
              };
            }
          ]
        });
      };

      $scope.deleteSphere = function(id, ev, index) {
        var confirm = $mdDialog
          .confirm({
            preserveScope: true,
            parent: angular.element(document.body)
          })
          .title('Confirmer la suppression de ce groupe ?')
          .textContent('')
          .ariaLabel('Supprimer le groupe')
          .ok('Confimer')
          .cancel('Annuler')
          .targetEvent(ev);

        $mdDialog.show(confirm).then(function() {
          api.deleteSphere(id).then(function(data) {
            $scope.spheres.splice(index, 1);
            if ($scope.sphere && $scope.sphere.id === id) {
              $scope.close();
            }
            $mdToast.show(
              $mdToast
                .simple()
                .textContent('Le groupe a bien été supprimé')
                .position('bottom right')
                .hideDelay(3000)
            );
          });
        });
      };

      $scope.downloadStudentsInfos = $event => {
        api
          .getInstitutionStudentsInfoInCSV('manager', $scope.sphere.id)
          .then(res => {
            var BOM = '\uFEFF';

            var encodedUri = encodeURI(
              'data:text/csv;charset=utf-8,' + BOM + res
            );
            var link = document.createElement('a');
            link.setAttribute('href', encodedUri);
            link.setAttribute('download', `students-${$scope.sphere.name}.csv`);
            document.body.appendChild(link);

            link.click(); // This will download the data file named "my_data.csv".
          });
      };

      $scope.show = function(sphere) {
        $scope.sphere = sphere;
      };

      $scope.close = function() {
        $scope.sphere = null;
      };

      var fuse;
      function onInit() {
        getSpheres();

        api
          .getInstitutionProfiles(
            'student',
            $scope.isManager ? 'manager' : 'teacher'
          )
          .then(data => {
            console.log('data', data);
            var options = {
              keys: [
                'user.email',
                'user.first_name',
                'user.last_name',
                'user.username'
              ]
              // id: 'profile.id'
            };

            students = data.profiles;
            fuse = new Fuse(data.profiles, options);
          });
      }
      onInit();

      function getSpheres() {
        console.log('🔥', $scope.isManager);
        api
          .getMySpheres($scope.isManager ? 'manager' : 'teacher')
          .then(function(data) {
            $scope.spheres = data;
          });
      }

      $scope.selectedItem = null;
      $scope.searchText = null;
      $scope.selectedStudents = null;

      $scope.addStudent = function(s) {
        if (
          _.find(
            $scope.sphere.profile_sphere_associations,
            (student: any) => s.id === student.id
          )
        ) {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("L'apprenant est déjà dans le groupe")
              .position('bottom right')
              .hideDelay(3000)
          );
          return;
        }
        api.addStudent(s.id, $scope.sphere.id).then(function(data) {
          $scope.sphere.profile_sphere_associations.push(s);
          $scope.selectedStudents = null;
        });
      };

      $scope.toggleRight = () => {
        console.log('yoolo');
        $mdSidenav('right')
          .toggle()
          .then(() => {
            $scope.studentsToAdd = null;
            $scope.addStudents = () => {
              if ($scope.studentsToAdd) {
                let emails: string[] = $scope.studentsToAdd
                  .split('\n')
                  .map((s: string) => s.trim().toLowerCase());
                // console.log('emails', emails, $scope.studentsToAdd);
                let goodProfiles = emails
                  .filter(email => email.length)
                  .map(email =>
                    _.find(students, (s: any) => s?.user?.email === email)
                  );
                console.log('goodProfiles', goodProfiles);
                goodProfiles.forEach((profile, index) => {
                  setTimeout(() => {
                    if (profile) {
                      $scope.addStudent(profile);
                    } else {
                      $mdToast.show(
                        $mdToast
                          .simple()
                          .textContent(
                            `Pas trouvé d'apprenant pour : ${emails[index]}`
                          )
                          .position('bottom right')
                          .hideDelay(3000)
                      );
                    }

                    if (goodProfiles.length - 1 === index) {
                      $mdSidenav('right').toggle();
                    }
                  }, index * 200);
                });
              }
            };
          });
      };

      $scope.deleteStudent = function(id, ev, index) {
        api.removeStudent(id, $scope.sphere.id).then(function(data) {
          $scope.sphere.profile_sphere_associations.splice(index, 1);

          $mdToast.show(
            $mdToast
              .simple()
              .textContent("L'apprenant a bien été retiré du groupe")
              .position('bottom right')
              .hideDelay(3000)
          );
        });
      };

      $scope.querySearch = function(query) {
        var results = fuse.search(query);
        console.log(results);
        return results;
      };
    }
  ])

  .controller('TeacherCorrectionCtrl', [
    '$scope',
    'api',
    '$mdDialog',
    '$mdToast',
    'EXAM',
    '$mdSidenav',
    async function($scope, api, $mdDialog, $mdToast, EXAM, $mdSidenav) {
      $scope.role = window.location.pathname.includes('/t/')
        ? 'teacher'
        : 'user';

      $scope.spheres =
        $scope.role === 'user'
          ? await api.getLearnerSpheresByProfileId()
          : (await api.getMySpheres('teacher'))
              .map(s => s.profile_sphere_associations)
              .flat();
    }
  ]);
